import { useNavigate } from "react-router-dom";
import { useState, useCallback } from "react";
import { getIdeProjects } from "../services/ide-apis";
import { Link } from "react-router-dom";
import { global_var } from "../services/cs-lab-config";
import {
  message,
  Card,
  List,
  Avatar,
  Typography,
  Divider,
  Badge,
  Row,
  Col,
  Button,
  Empty,
} from "antd";
import {
  StarFilled,
  UserOutlined,
  LeftOutlined,
  CheckCircleFilled
} from "@ant-design/icons";
import {
  formatDate,
  getIdeProjectLogo,
  getEvaluationStatusColor,
  getEvaluationStatusName,
  getIdeProjectTypeMetaData,
  trackEvent,
} from "./utils/util-functions";
import CardSkeleton from "./utils/card-skeleton";
import ProjectFilters from "./utils/project-filters";
import { ReactComponent as PendingIcon } from './../assets/logos/pending.svg';
import { ReactComponent as ResubmissionIcon } from './../assets/logos/resubmission.svg';
import  noDataImage  from '../assets/images/No notifcations.png'


const { Meta } = Card;

const Portfolio = () => {
  document.title = "CS Lab | Portfolio";

  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [totalProjectsCount, setTotalProjectsCount] = useState(0);
  const [projectLoading, setProjectLoading] = useState(false);

  function handleEvaluateProject(projectObj) {
    const projectMetaData = getIdeProjectTypeMetaData(
      projectObj.projectLanguage
    );

    trackEvent("portfolio_page_view_button_clicked", {
      ide_project_stack_name: projectObj.projectLanguage,
    });

    if (projectMetaData ? projectMetaData.route : false) {
      if (projectObj.projectLanguage === "sql2") {
        navigate(projectMetaData.route + projectObj.queryId);
      } else {
        navigate(projectMetaData.route + projectObj._id);
      }
    } else {
      message.info("Coming soon.");
    }
  }

  const filtersChanged = useCallback((filters) => {
    setProjectLoading(true);

    const reqObj = {
      ...filters,
      fkCompanyId: global_var.company_id,
      portfolio: true,
      limitCount: 12,
      from: "csLab",
      restrictProjects: true,
    };

    if (global_var.role_id === global_var.STUDENT_ROLE_ID) {
      reqObj.userLoginId = global_var.user_login_id;
    } else {
      reqObj.teacherUserLoginId = global_var.user_login_id;
    }

    reqObj.pageNo = reqObj.pageNo - 1;

    getIdeProjects(reqObj).then((response) => {
      setProjectLoading(false);
      response = response.data;

      if (response.statusCode === 200) {
        setProjects(response.projects);
        setTotalProjectsCount(response.totalProjectsCount);
      } else {
        message.error(response.message);
      }
    });
  }, []);

  return (
    <>
      <Row className="mt-4">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Link to="/" className="mr-2">
            <span className="mt-2 back-button">
              <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
            </span>
          </Link>
          <span className="m-1 h4 poppins-medium">
            {global_var.role_id === global_var.STUDENT_ROLE_ID
              ? "My "
              : "Student "}
            Portfolio
          </span>
        </Col>
      </Row>
      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}}/>

      <ProjectFilters
        filtersChanged={filtersChanged}
        totalProjectsCount={totalProjectsCount}
        hideClassFilter ={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} 
        hideDivisionFilter ={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
        hideAcademicYearFilter = {true} 
      />

      <div className="row mx-2 left-padding">
        <div className="col">
          {projectLoading ? (
            <List
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={Array(8).fill(0)}
              renderItem={() => (
                <List.Item className="mr-2 mb-5">
                  <CardSkeleton />
                </List.Item>
              )}
            />
          ) : (
            <List
              locale={{
                emptyText: (
                  <Empty
                    image={noDataImage}
                    description={
                      <div>
                        <p className="poppins-regular" style={{fontSize:'18px'}}>No Projects yet!</p>
                      </div>
                    }
                  />
                ),
              }}
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={projects}
              renderItem={(projectObj) => (
                <List.Item className="mr-2 mb-3">
                    <Card
                      className="glass card-divider"
                      actions={[
                        <div key="" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '15px', paddingRight: '15px' }}>
                            {projectObj.submittedForEvaluation ?
                                <span className="poppins-medium"
                                    key="evaluationStatus"
                                    style={{
                                        color: getEvaluationStatusColor(projectObj.evaluationStatus),fontSize:'12px'
                                    }}
                                >
                                  {projectObj.evaluationStatus === 'Ask for resubmission' ? <ResubmissionIcon /> :
                                    projectObj.evaluationStatus === 'Evaluated' ? <CheckCircleFilled style={{ color: "#2AC14E", borderRadius: '4px', padding: '2px' }} /> :
                                    <PendingIcon />}
                                   {getEvaluationStatusName(projectObj.evaluationStatus)}
                                </span>
                                :
                                <div /> // Empty placeholder for alignment
                            }
                            
                            <Button className="poppins-medium"
                                type="default"
                                style={{
                                    backgroundColor:"#FFFFFF",
                                    borderColor: "#E96358",
                                    borderRadius: "10px",
                                    color: "#E96358",
                                    fontSize:'12px'
                                }}
                                onClick={() => {
                                    handleEvaluateProject(projectObj)
                                }}
                            >
                              {global_var.role_id !== global_var.STUDENT_ROLE_ID ? (
                                <span>Open</span>
                              ) : (
                                projectObj.evaluationStatus === 'Evaluated' ? (
                                  <span>Open</span>
                                ) : (
                                  <span>Edit Project</span>
                                )
                              )}
                            </Button>
                        </div>
                    ]}
                    >
                      <Meta
                        avatar={
                          <div style={{ marginTop: '15px' }}>
                            <Badge
                              style={{ color: "#0057ff" }}
                              count={
                                projectObj.showInPortFolio ? <StarFilled style={{color:'#FFC200'}} /> : 0
                              }
                            >
                              <Avatar
                              size={{
                                xs: 24,
                                sm: 32,
                                md: 40,
                                lg: 34,
                                xl: 50,
                                xxl: 30,
                              }}
                                src={getIdeProjectLogo(
                                  projectObj.projectLanguage
                                )}
                              />
                            </Badge>
                          </div>
                        }
                        title={
                          <Typography.Text className="poppins-regular"
                            ellipsis={{ tooltip: projectObj.name }}
                          >
                            {projectObj.name}
                          </Typography.Text>
                        }
                        description={
                          <>
                            {global_var.role_id !==
                              global_var.STUDENT_ROLE_ID && (
                              <div className="d-flex align-items-center">
                                <UserOutlined className="me-1" />
                                <Typography.Text
                                  ellipsis={{
                                    tooltip: projectObj.studentName,
                                  }}
                                >
                                  {projectObj.studentName}
                                </Typography.Text>
                              </div>
                            )}
                            <div className="d-flex align-items-center">
                              <Typography.Text className="poppins-regular" style={{fontSize:'12px'}}
                                ellipsis={{
                                  tooltip: formatDate(projectObj.createdDate),
                                }}
                              >
                                {formatDate(projectObj.createdDate)}
                              </Typography.Text>
                            </div>
                          </>
                        }
                      />
                    </Card>
                </List.Item>
              )}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Portfolio;
